import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrl: './nav.component.css'
})
export class NavComponent implements OnInit {

  constructor(private apiService: ApiService) { }

  open: boolean = false;
  navCompressed: boolean = false;
  carnetAttivo: boolean = false;

  scrollPosY: number = 0;

  ngOnInit(): void {
    this.apiService.getCarnetInfo().subscribe({
      next: (data) => this.carnetAttivo = !!data?.attivo,
      error: () => this.carnetAttivo = false,      
    })
  }

}
